<template>
	<div>
		<topTab ref="topTab" :tabData='tabData' @tabChange='changePages'>
			<appVersion v-if="activeTab === '1'" :type="1"></appVersion>
			<webVersion v-if="activeTab === '2'" :type="2"></webVersion>
		</topTab>
	</div>
</template>

<script>
import appVersion from './versionList.vue';
import webVersion from './versionList.vue';
export default {
	data() {
		return {
			activeTab: '1',
			tabData: [{
				key: '1',
				value: 'app版本'
			},
			{
				key: '2',
				value: 'web版本',
			},],
		};
	},
	// 注册组件
	components: {
		appVersion,
		webVersion,
	},
	created() {
	},
	watch: {},
	computed: {},
	methods: {
		// 顶部tab页面切换
		changePages(tab) {
			this.activeTab = tab
		},
	},
};
</script>